export default "__VITE_ASSET__CFK0JQTT__"